import { Injectable } from '@angular/core';
import { ResultType } from 'ng/src/app/core/Result';
import { Utils } from 'ng/src/app/core/utils';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class CommandPaletteService {
	
	private _actionsSubject = new BehaviorSubject<ReadonlyArray<CommandPaletteAction>>([]);
	readonly actions = this._actionsSubject.asObservable();
	
	private _addCount = 0;
	
	register(...actions: CommandPaletteAction[]): CommandPaletteRegistration {
		const addCount = this._addCount += 1;
		const newActions = actions.map(a => {
			return {
				...a,
				index: addCount,
			}
		}) as CommandPaletteAction[];
		
		const id = setTimeout(() => {
			this.updateActions((actions) => {
				return [...actions, ...newActions];
			});
		});

		return {
			unregister: () => {
				clearTimeout(id);
				this.updateActions((actions) => {
					return actions.filter(action => !newActions.includes(action));
				});
			}
		};
	}
	
	private updateActions(fn: (actions: CommandPaletteAction[]) => CommandPaletteAction[]) {
		ResultType.tryCatch(() => {
			return fn([...this._actionsSubject.value]);
		})
			.toOption()
			.whenSome(val => {
				val.sort(Utils.createMultiSortFunction([
					['index', 'desc'],
					['group', 'asc'],
					['label', 'asc'],
				]));
				
				this._actionsSubject.next(Object.freeze(val));
			});
	}
}

export interface CommandPaletteAction {
	label: string;
	command: () => void;
	tags?: string[];
	title?: string;
	icon?: string;
	group?: string;
	index?: number;
}

export interface CommandPaletteRegistration {
	unregister: () => void;
}